// extracted by css-extract-rspack-plugin
export default {"errorWrapper":"SubmissionError_errorWrapper__fQKW6","errorIconWrapper":"SubmissionError_errorIconWrapper__gv5i9","emailLink":"SubmissionError_emailLink__ntcpR"};